@if (healthAssessmentGridData !== null) {
  <ppl-accordion title="Health Assessments" [isOpen]="true">
    <div class="health-assessment-meta">
      @if (healthAssessmentVendor) {
        <div class="meta-item">
          <i class="fa fa-building meta-icon" aria-hidden="true"></i>
          <span class="meta-label">Vendor</span>
          <span class="meta-badge meta-badge--vendor">{{ healthAssessmentVendor }}</span>
        </div>
      }
      @if (healthAssessmentProgress) {
        <div class="meta-item">
          <i class="fa fa-tasks meta-icon" aria-hidden="true"></i>
          <span class="meta-label">Progress</span>
          @if ((healthAssessmentDaysRemaining !== null && healthAssessmentDaysRemaining <= 30 && healthAssessmentProgress === 'Completed') || healthAssessmentProgress === 'Compliant Expired') {
            @if (healthAssessmentDaysRemaining === 0 || healthAssessmentProgress === 'Compliant Expired') {
              <span class="meta-badge meta-badge--expired">Expired</span>
            } @else {
              <span class="meta-badge meta-badge--expiring">Expiring in {{ healthAssessmentDaysRemaining }} days</span>
            }
          } @else {
            <span class="meta-badge meta-badge--progress">{{ healthAssessmentProgress }}</span>
          }
        </div>
      }
    </div>
    <div class="ant-row" style="justify-content: center">
      <div class="ant-col-24">
        <ppl-list-table
          [disableSort]="true"
          [disableSearch]="true"
          [data]="healthAssessmentGridData"
          [disableSelection]="true"
          [cols]="cols"
          [gridTitle]="false"
          [pagination]="false"
          [boldFirstRow]="true"
        ></ppl-list-table>
      </div>
    </div>
  </ppl-accordion>
}
